import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Speech({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Speech.Outline {...props} /> : <Speech.Solid {...props} />;
}

Speech.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6016 4.3959C15.4073 0.201188 8.59394 0.201188 4.39969 4.39697C1.11841 7.67767 0.406781 12.5347 2.23727 16.5095C2.46622 17.0801 2.56713 17.3756 2.56713 17.6266C2.56713 17.8144 2.52039 18.047 2.43106 18.3435C2.38739 18.4884 2.33741 18.6367 2.28329 18.7955L2.26866 18.8384C2.22004 18.9809 2.16814 19.1331 2.12132 19.2831C2.02131 19.6034 1.91929 19.9884 1.91929 20.3734C1.91929 20.7849 2.03735 21.2317 2.40321 21.5976C2.76911 21.9631 3.21546 22.0807 3.62693 22.0804C4.01194 22.0802 4.39661 21.9778 4.7168 21.8773C4.86912 21.8294 5.02346 21.7764 5.16782 21.7267L5.20392 21.7143C5.36257 21.6598 5.51052 21.6094 5.65523 21.5652C5.95012 21.4752 6.18117 21.4275 6.36738 21.426C6.6157 21.4266 6.91473 21.5319 7.48903 21.7629C11.4643 23.5926 16.3201 22.882 19.6016 19.6002C23.7954 15.4059 23.8032 8.59794 19.6016 4.3959ZM5.46055 5.45744C9.06898 1.84768 14.9324 1.84768 18.5409 5.4565C22.156 9.07208 22.1497 14.9303 18.5409 18.5396C15.7149 21.3658 11.5293 21.9787 8.10109 20.3933C8.08966 20.388 8.07808 20.383 8.06639 20.3783L8.01186 20.3563C7.51777 20.1571 6.94482 19.926 6.36524 19.926L6.36079 19.926C5.95396 19.9284 5.55595 20.0272 5.21726 20.1306C5.04456 20.1833 4.87385 20.2416 4.71647 20.2957L4.68398 20.3069C4.53551 20.3579 4.39938 20.4047 4.26735 20.4462C3.97388 20.5383 3.77107 20.5803 3.62604 20.5804C3.50825 20.5805 3.48158 20.5547 3.46358 20.5367C3.44554 20.5186 3.41929 20.4923 3.41929 20.3734C3.41929 20.2279 3.46123 20.0246 3.55317 19.7301C3.59384 19.5998 3.6394 19.4662 3.68921 19.3201L3.70312 19.2793C3.75698 19.1212 3.81497 18.9498 3.86728 18.7763C3.9699 18.4357 4.06713 18.0357 4.06713 17.6266C4.06713 17.0398 3.83793 16.4696 3.63464 15.9639L3.62212 15.9328C3.61733 15.9209 3.61223 15.9091 3.60684 15.8974C2.02077 12.47 2.63459 8.28278 5.46055 5.45744Z"
        fill="currentColor"
      />
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Speech.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
